export const exploreServiceContents = [
  [
    {
      image: 'retailSalesRep',
      title: 'Retail Sales Representative',
      alt: 'Retail Sales Representative Icon'
    },
    {
      image: 'outsideSalesRep',
      title: 'Outside Sales Representative',
      alt: 'Outside Sales Representative icon'
    }
  ],
  [
    {
      image: 'distributingPamp',
      title: 'Distributing Pamphlets',
      alt: 'Distributing Pamphlets icon'
    },
    { image: 'surveys', title: 'Surveys', subtext: 'Survey work involves conducting in-person or direct surveys to gather data or feedback.', alt: 'Surveys icon' }
  ],
  [
    {
      image: 'sellerOnboarding',
      title: 'Seller Onboarding',
      alt: 'Seller Onboarding icon'
    },
    {
      image: 'merchantOnboarding',
      title: 'Merchant Onboarding',
      alt: 'Merchant Onboarding icon'
    }
  ],
  [
    {
      image: 'bandsAwarenessRep',
      title: 'Brand Awareness Representative',
      alt: 'Brand Awareness Representative icon'
    },
    {
      image: 'leadGenerationRep',
      title: 'Lead Generation Representative',
      alt: 'Lead Generation Representative icon'
    }
  ]
];
